import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil, tap } from 'rxjs/operators';
import { ResponsiveService } from './responsive.service';
import { BreakpointInfo } from './responsive.types';

@Directive({
  selector: '[xResponsiveIf]',
})
export class ResponsiveIfDirective implements OnDestroy, OnInit {
  private _destroy$ = new Subject<void>();

  @Input('xResponsiveIf')
  breakpoint: BreakpointInfo;

  @Input('xResponsiveIfElse')
  else: TemplateRef<any>;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cd: ChangeDetectorRef,
    private responsiveService: ResponsiveService,
  ) {}

  ngOnInit(): void {
    this.responsiveService
      .observeIsBreakpoint(this.breakpoint)
      .pipe(
        startWith(this.responsiveService.isBreakpoint(this.breakpoint)),
        tap((isBreakpoint) => {
          if (isBreakpoint) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);

            //have to invoke changeDetection because parent component uses onPush
            this.cd.markForCheck();
          } else {
            this.viewContainer.clear();
            if (this.else) {
              this.viewContainer.createEmbeddedView(this.else);
            }
            this.cd.markForCheck();
          }
        }),
        takeUntil(this._destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
